<div
  class="ag-header-select-all ag-labeled ag-label-align-right ag-checkbox ag-input-field"
>
  <div class="ag-input-field-label ag-label ag-hidden ag-checkbox-label"></div>
  <div
    class="ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper"
    [class.ag-checked]="isSelected"
  >
    <input
      class="ag-input-field-input ag-checkbox-input ag-selection-checkbox--middle"
      type="checkbox"
      [id]="uniqueInputId"
      [ngModel]="isSelected"
      (click)="onSelectAllClick($event)"
    />
    <label [for]="uniqueInputId" class="sr-only">
      {{ params?.checkboxLabel }}</label
    >
  </div>
</div>
